<div class="container-sm" style="max-width: 1200px;">
    <h1 class="m-3 display-6 vm-container-header">Admin User Management</h1>

    <div class="pb-5">
        <div class="m-3 bg-body-light rounded-3 shadow">
            <div class="m-2">
                <table class="table table-striped table-hover">
                    <caption>
                        <div class="container-fluid">
                            <div class="row justify-content-center align-self-center">
                                <div class="col align-self-center">
                                    {{ this.total$ | async }} Total
                                </div>
                                <div class="col text-end">
                                    <i class="btn btn-sm btn-outline-primary bi bi-person-plus" (click)="onAddUser()"></i>
                                </div>
                            </div>
                        </div>
                    </caption>

                    <thead>
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col" class="text-center">Active</th>
                        <th scope="col"></th>
                    </tr>
                    </thead>

                    <tbody class="table-group-divider">
                        @for (element of this.users$ | async; track element.id; let i = $index) {
                            <tr>
                                <td class="align-middle">{{ element.fullName }}</td>
                                <td class="align-middle">{{ element.email }}</td>
                                <td class="align-middle text-center">
                                    @if (element.isEnabled) {
                                        <i class="bi bi-check-lg text-success status"></i>
                                    } @else {
                                        <i class="bi bi-x text-danger status"></i>
                                    }
                                </td>
                                <td class="align-middle text-end">
                                    <div class="btn-group">
                                        <i class="btn btn-sm btn-outline-primary bi bi-pencil" (click)="onEdit(element)"></i>
                                        <button type="button" class="btn btn-sm btn-outline-primary bi bi-clock-history"
                                                title="View this admin's activity"
                                                [attr.aria-label]="'Activity of ' + element.fullName"
                                                (click)="onActivity(element)"></button>
                                        <i class="btn btn-sm btn-outline-danger bi-trash" (click)="confirmDeleteUser(element)"></i>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>

                @if ((total$ | async)! > 17) {
                    <app-table-pager [total]="(total$ | async)!" [(page)]="service.page" [(pageSize)]="service.pageSize" />
                }
            </div>
        </div>

        <ng-template #addUserModal>
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="addUserModalLabel">
                    Add User
                </h1>
                <button (click)="onAddUserDismiss()" type="button" class="btn-close" aria-label="Close"></button>
            </div>

            <form [formGroup]="addUserForm" (ngSubmit)="onAddUserSubmit()">
                <div class="modal-body container-fluid">
                    <div class="row g-0">
                        <div class="form-floating col-md-12 mt-3">
                            <input type="text" class="form-control" id="addUserFullNameControl" formControlName="fullName">
                            <label for="addUserFullNameControl" class="form-label">Full Name</label>
                        </div>

                        <div class="form-floating col-md-12 mt-3">
                            <input type="text" class="form-control" id="addUserEmailControl" formControlName="email">
                            <label for="addUserEmailControl" class="form-label">Email</label>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button [disabled]="savingData" type="submit" class="btn btn-primary">
                        @if (savingData) {
                            <span class="spinner-border spinner-border-sm me-1"></span>
                        }
                        Save
                    </button>
                    <button (click)="onAddUserDismiss()" type="button" class="btn btn-secondary">Close</button>
                </div>
            </form>
        </ng-template>

        <ng-template #editModal>
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="editModalLabel">
                    Edit User
                </h1>
                <button (click)="onEditDismiss()" type="button" class="btn-close" aria-label="Close"></button>
            </div>

            <form [formGroup]="editForm" (ngSubmit)="onSubmit()">
                <div class="modal-body container-fluid">
                    <div class="row g-0">
                        <div class="form-floating col-md-12 mt-3">
                            <input type="text" class="form-control" id="fullNameControl" formControlName="fullName">
                            <label for="fullNameControl" class="form-label">Full Name</label>
                        </div>

                        <div class="form-floating col-md-12 mt-3">
                            <div class="form-check form-check-inline form-switch">
                                <input class="form-check-input" type="checkbox" role="switch" id="isEnabledControl" formControlName="isEnabled" [checked]="this.editForm.value.isEnabled">
                                <label class="form-check-label" for="isEnabledControl">Active</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button [disabled]="savingData" type="submit" class="btn btn-primary">
                        @if (savingData) {
                            <span class="spinner-border spinner-border-sm me-1"></span>
                        }
                        Save
                    </button>
                    <button (click)="onEditDismiss()" type="button" class="btn btn-secondary">Close</button>
                </div>
            </form>
        </ng-template>

        <app-modal-confirm #confirmationModal></app-modal-confirm>
    </div>
</div>
